module.exports = __webpack_public_path__ + "static/media/macbook.5acbf936.png";